import { convertBoundingBoxToBox, transformBoxPoints } from './basler-components.es876.js';

function measureViewportBox(instance, transformPoint) {
    return convertBoundingBoxToBox(transformBoxPoints(instance.getBoundingClientRect(), transformPoint));
}

export { measureViewportBox };
